import { newAdExtensionsAssociationsContainer } from './new-ad-extensions-associations-container-styles';
import type { AdExtensionsAssociationsLayout, FixedListBoxWidthOptions } from '../../types.d';


export const adExtensionsAssociationsContainerLayoutType = {
  ExpandHorizontallyToContainer: 'ExpandHorizontallyToContainer',
  FixedListBoxWidth: 'FixedListBoxWidth',
};

const adExtensionsAssociationsContainerLayout = {
  [adExtensionsAssociationsContainerLayoutType.ExpandHorizontallyToContainer]: () => ({
    type: adExtensionsAssociationsContainerLayoutType.ExpandHorizontallyToContainer,
    layoutColumnsContainerGridTemplateColumns: 'minmax(0px, 1fr) minmax(0px, 1fr)',
  }),
  [adExtensionsAssociationsContainerLayoutType.FixedListBoxWidth]: ({
    listBoxWidthPx,
  }: FixedListBoxWidthOptions) => ({
    type: adExtensionsAssociationsContainerLayoutType.FixedListBoxWidth,
    layoutColumnsContainerGridTemplateColumns: `${listBoxWidthPx}px ${listBoxWidthPx}px`,
  }),
};

export const adExtensionsAssociationsContainer =
  (layoutType = adExtensionsAssociationsContainerLayoutType.ExpandHorizontallyToContainer) =>
    newAdExtensionsAssociationsContainer((adExtensionsAssociationsContainerLayout[layoutType] as unknown as () => AdExtensionsAssociationsLayout)());
